import { messageServiceStatusStateForAccountIdSelector } from '../../account/account-selectors';
import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const loadMessageServicesStatuses = (accountId: number) =>
  createGenericDispatcher<MessageServiceStatus[]>({
    name: 'MESSAGE_SERVICE_STATUS',
    loadFunction: () => Api.get(`/twilio-trust-hub/campaign-status?accountId=${accountId}`),
    args: { accountId },
    shouldExecuteSelector: (state: any) =>
      messageServiceStatusStateForAccountIdSelector(state, accountId),
  });
